var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFeed = function SvgFeed(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_4105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87939 10.6626H13.5541",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8914 6.3252H4.87939",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87939 15H17.8914",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2287 0.542236H0.541992V29.4579H22.2287V0.542236Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87939 19.3374H13.5541",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87939 23.6748H17.8914",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_4105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.7711,
    height: 30,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Feed.bf28228c.svg";